import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickAddService } from '../services/quick-add.service';
import { ConsoleTabService } from '../services/console-tab.service';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  @Input() isCollapsed = true;
  showMasterSearch: boolean = false;
  isDevEnvironment: boolean = !environment.production;

  constructor(private quickAddService: QuickAddService, private consoleTabService:ConsoleTabService,
    private router:Router,){
    this.consoleTabService.closeShowMasterSearchEvent.subscribe( e => this.showMasterSearch = e)
  }

  MENU_ITEMS_DASHBOARD = [
    { id: 1, value: 'dashboard', label: 'Dashboard', icon: 'dashboard', link: '/app/dashboard' },
    // { id: 2, value: 'search', label: 'Search', icon: 'search', link: '/app/search' },

  ];

  MENU_ITEMS_CONSOLES = [
    { id: 1, value: 'console', label: 'Console', icon: 'layout', link: '/app/console' }
  ]

  MENU_ITEMS_ACTIONS = [
    { id: 1, value: 'action-center', label: 'Action Center', icon: 'interaction', link: '/app/action-center' }
  ]


  COMPONENTS_ITEMS = [
    { id: 1, value: 'events', label: 'Events', icon: 'calendar', link: '/app/events' },
    { id: 2, value: 'tasks', label: 'Tasks', icon: 'reconciliation', link: '/app/tasks' },
    { id: 3, value: 'projects', label: 'Projects', icon: 'project', link: '/app/projects' },
    { id: 4, value: 'clients', label: 'Clients', icon: 'apartment', link: '/app/clients' },
    // { id: 5, value: 'venues', label: 'Venues', icon: 'build', link: '/app/venues' },
    { id: 5, value: 'venues', label: 'Venues', icon: 'home', link: '/app/venues' },

    { id: 6, value: 'vendors', label: 'Vendors', icon: 'shop', link: '/app/vendors' },
  ];

  REPORTS_ITEMS = [
    { id: 1, value: 'reports', label: 'Reports', icon: 'fund-view', link: '/app/reports' }
  ];

  SETTINGS_ITEMS = [
    { id: 1, value: 'settings', label: 'Settings', icon: 'setting', link: '/app/settings' }
  ];

  openMasterSearch(){
    this.showMasterSearch = true;
  }


  closeMasterSearch(){
    this.showMasterSearch = false;
  }


  openQuickApp(type: 'client' | 'project' | 'task'){
    this.quickAddService.openQuickAdd(type)
  }



}
